export enum LogLevel {
  All = 0,
  Debug = 1,
  Info = 2,
  Success = 3,
  Warn = 4,
  Error = 5,
  Off = 6
}
